import { EligibilityCheckStatus } from '@compass/client/types/eligibility';
import { EmailStatus } from '@compass/client/types/email';
import { GenericTaskStatus, GenericTaskType } from '@compass/client/types/generic_task';
import { TextStatus } from '@compass/client/types/text';

/**
 * Format eligibility check status for display
 */
export const getEligibilityCheckStatusDisplay = (status?: EligibilityCheckStatus): string => {
  switch (status) {
    case EligibilityCheckStatus.ELIGIBILITY_CHECK_STATUS_CREATED:
      return 'Created';
    case EligibilityCheckStatus.ELIGIBILITY_CHECK_STATUS_IN_PROGRESS:
      return 'In Progress';
    case EligibilityCheckStatus.ELIGIBILITY_CHECK_STATUS_COMPLETED:
      return 'Completed';
    case EligibilityCheckStatus.ELIGIBILITY_CHECK_STATUS_FAILED:
      return 'Failed';
    case EligibilityCheckStatus.ELIGIBILITY_CHECK_STATUS_CANCELLED:
      return 'Cancelled';
    case EligibilityCheckStatus.ELIGIBILITY_CHECK_STATUS_SKIPPED:
      return 'Skipped';
    default:
      return 'Unknown';
  }
};

/**
 * Format generic task type for display
 */
export const getGenericTaskTypeDisplayText = (type?: GenericTaskType): string => {
  switch (type) {
    case GenericTaskType.GENERIC_TASK_TYPE_GASTRO_CREATE_TASK:
      return 'Gastro Create Task';
    case GenericTaskType.GENERIC_TASK_TYPE_GASTRO_FAX_UPDATE_DESCRIPTION_TASK:
      return 'Gastro Fax Update Description';
    case GenericTaskType.GENERIC_TASK_TYPE_GASTRO_FAX_FILING_TASK:
      return 'Gastro Fax Filing';
    case GenericTaskType.GENERIC_TASK_TYPE_GASTRO_UPDATE_INELIGIBILITY_NOTE_TASK:
      return 'Gastro Update Ineligibility Note';
    case GenericTaskType.GENERIC_TASK_TYPE_GASTRO_CREATE_NEW_PATIENT_TASK:
      return 'Gastro Create New Patient';
    case GenericTaskType.GENERIC_TASK_TYPE_CARETEND_PROGRESS_NOTE:
      return 'CareTend Progress Note';
    case GenericTaskType.GENERIC_TASK_TYPE_CARETEND_DELIVERY_TICKET:
      return 'CareTend Delivery Ticket';
    default:
      return 'Generic Task';
  }
};

/**
 * Format generic task status for display
 */
export const getGenericTaskStatusDisplayText = (status?: GenericTaskStatus): string => {
  switch (status) {
    case GenericTaskStatus.GENERIC_TASK_STATUS_IN_PROGRESS:
      return 'Running';
    case GenericTaskStatus.GENERIC_TASK_STATUS_COMPLETED:
      return 'Completed';
    case GenericTaskStatus.GENERIC_TASK_STATUS_FAILED:
      return 'Failed';
    case GenericTaskStatus.GENERIC_TASK_STATUS_SCHEDULED:
      return 'Scheduled';
    default:
      return 'Unknown';
  }
};

/**
 * Format text message status for display
 */
export const getTextStatusDisplayText = (status?: TextStatus): string => {
  switch (status) {
    case TextStatus.TEXT_STATUS_CREATED:
      return 'Created';
    case TextStatus.TEXT_STATUS_IN_PROGRESS:
      return 'Sending';
    case TextStatus.TEXT_STATUS_SUCCESS:
      return 'Sent';
    case TextStatus.TEXT_STATUS_FAILED:
      return 'Failed';
    case TextStatus.TEXT_STATUS_IN_DRAFT:
      return 'Draft';
    default:
      return 'Unknown';
  }
};

/**
 * Format email status for display
 */
export const getEmailStatusDisplayText = (status?: EmailStatus): string => {
  switch (status) {
    case EmailStatus.EMAIL_STATUS_IN_DRAFT:
      return 'Draft';
    case EmailStatus.EMAIL_STATUS_SCHEDULED:
      return 'Scheduled';
    case EmailStatus.EMAIL_STATUS_IN_PROGRESS:
      return 'Sending';
    case EmailStatus.EMAIL_STATUS_SENT:
      return 'Sent';
    case EmailStatus.EMAIL_STATUS_DELIVERED:
      return 'Delivered';
    case EmailStatus.EMAIL_STATUS_FAILED:
      return 'Failed';
    default:
      return 'Unknown';
  }
};

/**
 * Determine attempt type based on case_state
 */
export const determineAttemptType = (caseState?: string): 'Primary' | 'Secondary' => {
  if (!caseState) return 'Primary';
  const lowerCaseState = caseState.toLowerCase();
  if (lowerCaseState.includes('primary')) return 'Primary';
  if (lowerCaseState.includes('secondary')) return 'Secondary';
  return 'Primary';
};
